
 export const address_1337 = {
  marketplace : "0x0DCd1Bf9A1b36cE34237eEaFef220932846BCD82" 
 } 
